<template>
  <div class="q-pa-md">
    <q-list bordered
            separator>
      <q-item v-ripple>
        <q-item-section caption>Importe Total:</q-item-section>
        <q-item-section>
          <b>{{ props.opts.Importe }} €</b>
        </q-item-section>
      </q-item>
      <q-item v-ripple>
        <q-item-section caption>Pagado:</q-item-section>
        <q-item-section>
          <b>{{ props.opts.Pagado }} €</b>
        </q-item-section>
      </q-item>
      <q-item v-ripple>
        <q-item-section>
          <q-item-section>Pago cliente:</q-item-section>
          <q-input clearable
                   dense
                   v-model.number="importe"
                   type="number"
                   filled></q-input>
        </q-item-section>
      </q-item>
      <q-item v-ripple>
        <q-item-section>
          <q-item-section>Destino:</q-item-section>
          <q-select v-model="destino"
                    :rules="[val => val && val.length > 0 || 'Selecciona']"
                    autofocus
                    :options="destinos"
                    @update:model-value="defineFormas"
                    label="Destino del pago"></q-select>
        </q-item-section>
      </q-item>
      <q-item v-ripple>
        <q-item-section>
          <q-item-section>Forma:</q-item-section>
          <q-select v-model="forma"
                    :rules="[val => val && val.length > 0 || 'Selecciona']"
                    :options="formas"
                    label="Forma de pago"></q-select>
        </q-item-section>
      </q-item>
      <q-item v-ripple>
        <q-item-section>
          <q-item-section>Guardar cambios:</q-item-section>
          <q-btn label="Guardar"
                 icon="save"
                 color="primary"
                 @click="save"></q-btn>
        </q-item-section>
      </q-item>
    </q-list>
  </div>
</template>

<script setup>
import { inject, onMounted, ref, watch } from 'vue';
import { Dialog, Notify } from 'quasar';
const global = inject("global")
const importe = ref(0)
const destino = ref()
const destinos = ref(["OFICINA", "ANTICIPO", "BANCO", "REALE"])
const forma = ref()
const formas = ref([])
// DEFINES PROPS
const props = defineProps({ opts: {}, tab: '' })
const emit = defineEmits(['update']);

// FUNCTIONS
function defineFormas(d) {
  d == "OFICINA" ? formas.value = ["METALICO"] : ""
  d == "ANTICIPO" ? formas.value = ["METALICO", "TRANSFERENCIA"] : ""
  d == "BANCO" ? formas.value = ["TRANSFERENCIA", "LIQUIDO TOMADOR"] : ""
  d == "REALE" ? formas.value = ["BIZUM", "TARJETA"] : ""
}
async function save() {
  if ((importe.value + props.opts.Pagado) > props.opts.Importe) {
    Dialog.create({
      title: "Error en importe",
      message: "La suma de lo pagado más el importe introducido supera el valor del Importe del Recibo",
      persistent: true,
      ok: { color: "negative" },
    })
    return;
  }
  if ((importe.value + props.opts.Pagado) < props.opts.Importe && destino.value != 'ANTICIPO') {
    Dialog.create({
      title: "¿Es un anticipo?",
      message: "Has puesto un importe inferior al del recibo, pero el destino no es un ANTICIPO. Corrige el importe o cambia destino a ANTICIPO",
      persistent: true,
      ok: { color: "negative" },
    })
    return;
  }
  if ((importe.value + props.opts.Pagado) == props.opts.Importe && destino.value == 'ANTICIPO') {
    Dialog.create({
      title: "¿Error en Destino?",
      message: "El importe más anticipos pagados coincide con el importe del Recibo, el destino no puede ser un Anticipo.",
      persistent: true,
      ok: { color: "negative" },
    })
    return;
  }
  if (props.opts.Pagado > 0 && (importe.value + props.opts.Pagado) == props.opts.Importe) {
    Dialog.create({
      title: "Recibo completado",
      message: "Parece que el recibo se ha completado. Podemos crear una liquidación con el recibo pagado al 100% y ajustar los anteriores anticipos a este recibo \n ¿Estás de acuerdo?",
      cancel: true,
      persistent: true,
      ok: { color: "positive" },
    }).onOk(async () => {
      let data = [
        {
          table: "Liquidaciones",
          query: "insert",
          data: {
            FechaEfecto: props.opts.Fecha,
            Recibo: props.opts.Recibo,
            SM: props.opts.SM,
            Poliza: props.opts.Poliza,
            Detalle: props.opts.Cliente,
            Mediador: props.opts.Mediador,
            Importe: props.opts.Importe,
            Origen: 'RECIBO',
            Destino: destino.value,
            Forma: forma.value,
            Usuario: global.user.name
          }
        },
        {
          table: "Liquidaciones",
          query: "insert",
          data: {
            FechaEfecto: props.opts.Fecha,
            Recibo: props.opts.Recibo,
            SM: props.opts.SM,
            Poliza: props.opts.Poliza,
            Detalle: props.opts.Cliente,
            Mediador: props.opts.Mediador,
            Importe: props.opts.Pagado,
            Origen: 'ANTICIPO',
            Destino: 'RECIBO',
            Forma: 'DARE',
            Usuario: global.user.name
          }
        }
      ]
      global.db("/app/db/insLiqCobro", data)
    });
  } else {
    let data = [{
      table: "Liquidaciones",
      query: "insert",
      data: {
        FechaEfecto: props.opts.Fecha,
        Recibo: props.opts.Recibo,
        SM: props.opts.SM,
        Poliza: props.opts.Poliza,
        Detalle: props.opts.Cliente,
        Mediador: props.opts.Mediador,
        Importe: importe.value,
        Origen: 'RECIBO',
        Destino: destino.value,
        Forma: forma.value,
        Usuario: global.user.name
      }
    }]
    const r = await global.db("/app/db/insCobro", data)
    if (r.success === true) {
      emit('update', 'ok');
      Notify.create({ message: "Cobro registrado", color: "positive", timeout: 1000 });
    }
  }
}
function init() {
  importe.value = props.opts.Importe - props.opts.Pagado
  defineFormas(props.opts.Destino);
}
onMounted(() => { init() })
watch(() => props.tab, (n, o) => { if (props.tab == "tabC" && n !== o) init() })
</script>